import { RootState } from 'store/rootReducer';
import { getContractBasedDataSelector } from '@cp-shared-19/frontend-integration';

export const EarlySettlementHeaderDataSelector = getContractBasedDataSelector(
    (state: RootState) => state.earlySettlementHeader,
);
